<template>
  <div class="d-flex">
    <!--AUTH TOKEN-->
    <v-text-field
      v-model="smsSettings.smsDefinitions.authToken"
      :disabled="!isSettingsEnabled"
      label="Token"
      placeholder=" "
      class="mx-4"
      type="text"
    >
    </v-text-field>
    <!--USERNAME-->
    <v-text-field
      v-model="smsSettings.smsDefinitions.accountSid"
      :disabled="!isSettingsEnabled"
      label="Username"
      placeholder=" "
      class="mx-4"
      type="text"
    >
    </v-text-field>
    <!--SOURCE-->
    <v-text-field
      v-model="smsSettings.smsDefinitions.sender"
      :disabled="!isSettingsEnabled"
      label="Verified Name"
      placeholder=" "
      class="mx-4"
      type="text"
    >
    </v-text-field>
  </div>
</template>

<script>
export default {
  name: 'SMSTextMe',
  props: { smsSettings: Object, isSettingsEnabled: Boolean },
}
</script>
